import { useNavigate } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';

import { getAllTransactions } from 'api/Transaction';

export const useAllTransactions = ({ params = {}, options = {}, dependencies = [], name }) => {
  const navigate = useNavigate();
  return useQuery([name, ...dependencies], () => getAllTransactions(navigate, params), {
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...options
  });
};
